import { createSlice } from "@reduxjs/toolkit";
import { getNotes, createOrUpdateNote, deleteNote } from "../thunks/noteThunks";
import { NoteDTO } from "../../models/Note.model";
import { getLeadData } from "../thunks/leadThunks";
import { projectSwitched } from "../actions/projectLifecycleActions";

interface NoteState {
  notes: NoteDTO[];
  loading: boolean;
  error: string | null;
}

const initialState: NoteState = {
  notes: [],
  loading: false,
  error: null,
};

const noteSlice = createSlice({
  name: "note",
  initialState,
  reducers: {
    clearNoteError(state) {
      state.error = null;
    },
    clearNotes(state) {
      state.notes = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(projectSwitched, (state) => {
        state.notes = [];
        state.loading = false;
        state.error = null;
      })
      .addCase(getNotes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotes.fulfilled, (state, action) => {
        state.loading = false;
        state.notes = action.payload.notes;
      })
      .addCase(getNotes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "שגיאה בקבלת הערות";
      })
      .addCase(getLeadData.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.notes = [];
      })
      .addCase(getLeadData.fulfilled, (state, action) => {
        state.loading = false;
        const leadComments = Array.isArray(action.payload.lead?.comments)
          ? action.payload.lead.comments
          : [];

        state.notes = leadComments.map((n) => {
          return {
            note_ID: n.noteID,
            note_EntityType: "project",
            note_EntityID: action.meta.arg.projectID,
            note_Type: "text",
            note_Content: n.content,
            note_Meta: "",
            note_CreatedAt: n.createdAt,
            webUser_FullName: n.createdBy,
          };
        });
        //   export interface NoteDTO {
        //     note_ID: number;
        //     note_EntityType: string;
        //     note_EntityID: number;
        //     note_Type: string;
        //     note_Content: string;
        //     note_Meta: string;
        //     note_CreatedAt: string; // Date as ISO string
        //     webUser_FullName?: string;
        //   }
        //   export interface CommentLeadData {
        //     noteID: number;
        //     content: string;
        //     createdAt: string;
        //     createdBy: string;
        //   }
      })
      .addCase(getLeadData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "שגיאה בקבלת נתוני הליד";
      })

      .addCase(createOrUpdateNote.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createOrUpdateNote.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        // הוספת הערה חדשה למערך אם התקבלה
        if (action.payload && action.payload.noteID) {
          state.notes.push({
            note_ID: action.payload.noteID,
            note_EntityType: action.meta.arg.entityType,
            note_EntityID: action.meta.arg.entityID,
            note_Type: action.meta.arg.noteType,
            note_Content: action.meta.arg.noteContent,
            note_Meta: action.meta.arg.noteMeta,
            note_CreatedAt: new Date().toISOString(),
            webUser_FullName: (action.meta.arg as any).userFullName || "",
          });
        }
      })
      .addCase(createOrUpdateNote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "שגיאה ביצירת/עדכון הערה";
      })
      .addCase(deleteNote.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteNote.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        // הסרת הערה שנמחקה
        if (action.payload && action.payload.noteID) {
          state.notes = state.notes.filter(
            (note) => note.note_ID !== action.payload.noteID,
          );
        }
      })
      .addCase(deleteNote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "שגיאה במחיקת הערה";
      });
  },
});

export const { clearNoteError, clearNotes } = noteSlice.actions;
export default noteSlice.reducer;
